//     _       _ __
//    (_)___  (_) /_
//   / / __ \/ / __/
//  / / / / / / /_
// /_/_/ /_/_/\__/

const app = {
  controller: null,
  youtubePlayers: []
};

export { app };



// WEBPACK FOOTER //
// ./scripts/modules/app.js